export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7325.49097b1e.jpg";